import type { FC } from 'react';

import SkipNextRoundedIcon from '@mui/icons-material/SkipNextRounded';
import SkipPreviousRoundedIcon from '@mui/icons-material/SkipPreviousRounded';
import { colorsSelector } from '@redux/colorPalette/selectors';
import { useSelector } from 'react-redux';

import ControlButton from './ControlButton';
import { ControlButtons } from './Controls.style';
import type { IControls } from './Icontrols';

const Controls: FC<IControls> = ({
  handleRestartSongClick,
  controlsDisabled,
  PlayPauseIcon,
  handlePlayPauseClick,
  handlePlayNextSongClick,
  nextSongId,
}) => {
  const colors = useSelector(colorsSelector);

  return (
    <ControlButtons>
      <ControlButton
        Icon={SkipPreviousRoundedIcon}
        onClick={handleRestartSongClick}
        disabled={controlsDisabled}
        {...{ colors }}
      />
      <ControlButton
        Icon={PlayPauseIcon}
        onClick={handlePlayPauseClick}
        id='test-script-button'
        aria-label='play'
        playPlauseButton
        disabled={controlsDisabled}
        {...{ colors }}
      />
      <ControlButton
        Icon={SkipNextRoundedIcon}
        onClick={handlePlayNextSongClick}
        disabled={controlsDisabled || !nextSongId}
        {...{ colors }}
      />
    </ControlButtons>
  );
};

export default Controls;
